<template>
  <div>
    <div class="page-title">New Support Form</div>
    <Form btnText="Add Form" v-model="form" :submit="create" />
  </div>
</template>

<script>
import Form from "./_form.support.page";
export default {
  components: { Form },
  data() {
    return {
      form: null,
    };
  },
  created() {
    this.setForm();
  },
  methods: {
    async setForm() {
      const { data } = await this.$api.SupportForm.new();
      this.form = data;
    },
    async create() {
      await this.$api.SupportForm.create(this.form);
      this.$router.push("/support");
    },
  },
};
</script>

<style></style>
